import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

const dataBoth = require('./data/dataBoth.json');
const dataSingles = require('./data/dataSingles.json');
const dataDoubles = require('./data/dataDoubles.json');

const sourceData = [dataBoth.sort(function(a, b) { return a.y < b.y; }),
                    dataDoubles.sort(function(a, b) { return a.y < b.y; }),
                    dataSingles.sort(function(a, b) { return a.y < b.y; })];

class FighterStats extends Component {
    constructor(props){
        super(props);
        this.state = {mX: 0, mY: 0, clicked:false, xClick:0, xOff: 0, zoom:0, s:0, hover:null};
        this.handleKeyDown = this.handleKeyDown.bind(this);
        
        this.dim = {0:{size:106, charPadding:14, borderPadding:6, bevel:10, barWidth:74, height:152, font:34, altFont:34},
                    1:{size:54, charPadding:6, borderPadding:5, bevel:5, barWidth:36, height:116, font:34, altFont:22},
                    2:{size:36, charPadding:4, borderPadding:3, bevel:3, barWidth:24, height:93, font:20, altFont:12}};


        // initialize the placings
        this.placings = [[], [], []];
        let curPlacing = [1, 1, 1];
        for(let i=0; i<sourceData[0].length; i++) {
            for(let j=0; j<3; j++) {
                if(i > 0 && sourceData[j][i-1].y !== sourceData[j][i].y) {
                    // found the next placing
                    curPlacing[j] = i+1;
                }
                this.placings[j][i] = curPlacing[j];
            }
        }
    }

    componentWillMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    onMouseDown(e) {
        let x = e.clientX;
        e.preventDefault();
        
        this.setState(prevState => ({
            xClick: x + this.state.xOff,
            clicked: true
        }));
    }

    onMouseUp(e) {
        this.setState(prevState => ({
            clicked: false
        }));
    }

    getXOff(zoom) {
        let maxX = (this.dim[zoom].size + this.dim[zoom].charPadding)*dataBoth.length - 1920 + 80*2;        
        return Math.min(maxX, Math.max(0, this.state.xOff));
    }
    
    onMouseMove(e) {
        if (this.state.clicked) {
            let maxX = (this.dim[this.state.zoom].size + this.dim[this.state.zoom].charPadding)*dataBoth.length - 1920 + 80*2;
            let xOff = Math.min(maxX, Math.max(0, this.state.xClick - e.clientX));

            this.setState({ mX: e.clientX, mY: e.clientY, xOff:xOff });
        }
    }
    
    onMouseScroll(e) {
        let maxX = (this.dim[this.state.zoom].size + this.dim[this.state.zoom].charPadding)*dataBoth.length - 1920 + 80*2;
        let xOff = Math.min(maxX, Math.max(0, this.state.xOff + (15*e.deltaY)));
        this.setState({xOff:xOff});
        e.preventDefault();
    }
    
    
    handleKeyDown(e) {
        let newTab = 0;
        let tabs = 3;
        
        switch(e.key) {
        case 'ArrowLeft':
            newTab = (this.state.s - 1 + tabs) % tabs;
            this.setState({s:newTab});
            break;

        case 'ArrowRight':
            newTab = (this.state.s + 1) % tabs;
            this.setState({s:newTab});
            break;

        case 'ArrowUp':
            if (this.state.zoom < 2) {
                let zoom = this.state.zoom + 1;
                this.setState({zoom:zoom, xOff:this.getXOff(zoom)});
            }
            e.preventDefault();
            break;
            
        case 'ArrowDown':
            if (this.state.zoom > 0) {
                let zoom = this.state.zoom - 1;
                this.setState({zoom:zoom, xOff:this.getXOff(zoom)});
            }
            e.preventDefault();
            break;
            
        default:
            break;
        }

    }
    
    hover(e, i) {
        this.setState({hover: i});
    }
    
    select(i) {
        this.setState({s:i});
    }

    charContainerPath(width, height, bevel) {
        let bW = width - bevel;
        let bH = height - bevel;
        return "M0 0 L" + width + " 0 L" + width + " " + bH + " L" + bW + " " + height + " L" + bevel + " " + height + " L0 " + bH + " Z";
    }

    character(name, value, i, xOff, maxHeight, scale=1) {        
        let size = this.dim[scale].size;
        let charPadding = this.dim[scale].charPadding;
        let borderPadding = this.dim[scale].borderPadding;
        let bevel = this.dim[scale].bevel;
        let barWidth = this.dim[scale].barWidth;
        let height = this.dim[scale].height;
        let barPosition = (size - barWidth) / 2;
        let fontSize = this.dim[scale].font;
        let altFontSize = this.dim[scale].altFont;
        let placingPos = height - size - borderPadding*2;
        let transform = "translate(" + (80 + i*(size+charPadding) - xOff) + ", 547)";
        let h = 500 * value / maxHeight;
        let placing = this.placings[this.state.s][i];


        return (
            <g key={"characterGroup"+i} transform={transform} onMouseOver={(e) => this.hover(e, i)} className={this.state.hover === i ? "hover" : ""}>
              <path className="fighter-base" d={this.charContainerPath(size, height, bevel)} />
              <image href={getCharFilename(name, 0, "red")} width={size - borderPadding*2} height={size - borderPadding*2} x={borderPadding} y={borderPadding} />
              <rect className="fighter-bar" width={barWidth} height={Math.max(1, h)} x={barPosition} y={-h} />
              { (scale<2 || this.state.hover === i) && <text className="fighter-info" x={size/2} y={-h - 10} textAnchor={"middle"}>{value}</text>}
                         { (scale===0 || (i+1)%10===0 || i===0) && <text className="fighter-placing" x={size/2} y={height-placingPos/2} fontSize={fontSize + "px"} textAnchor={"middle"}>{placing}</text>}
                                    { (scale!==0 && (i+1)%10!==0 && i!==0) && <text className="fighter-placing-alt" x={size/2} y={height-placingPos/2-altFontSize/4} fontSize={altFontSize + "px"} textAnchor={"middle"}>{placing}</text>}
            </g>
        );
    }

    renderUnselectedTab(text) {
        return (
            <g>
              <path style={{fill:"#3a50a8", strokeWidth:0}} d="M6 88 L29 5 L433 5 L456 88 Z" />
              <text fill="#2b334c" fontSize="35" textAnchor="middle" fontWeight="900" x="235" y="65">{text}</text>
            </g>
        );
    }
    
    renderSelectedTab(text) {
        return (
            <g>
              <path style={{fill:"#343f5a", strokeWidth:0}} d="M25 0 L437 0 L462 94 L0 94 Z" />
              <path style={{fill:"#417cd9", strokeWidth:0}} d="M94 5 L368 5 L395 96 L69 96 Z" />
              <text fill="#e5e6e5" fontSize="50" textAnchor="middle" fontWeight="900" x="230" y="75">{text}</text>
            </g>
        );
    }


    render() {
        let tabs = ["Combined", "Team", "1-on-1"];
        let focused = [false, false, false];
        focused[this.state.s] = true;
        
        let source = sourceData[this.state.s];
        
        let xOff = this.state.xOff;
        let maxHeight = Math.max.apply(Math, dataBoth.map(function(obj){return obj.y;}));
        const divide = (<path style={{fill:"#242424", strokeWidth:0}} d="M433 5 L438 5 L456 88 L451 88 Z" />);
        
        source.sort(function(a, b) {
            return b.y - a.y;
        });

        let chars = source.map(function(value, i) {
            return this.character(value["x"], value["y"], i, xOff, maxHeight, this.state.zoom);
        }, this);

        let offset = 370;
        let svgTabs = (
            <g transform="translate(675, 22)">
              {
                  focused.map(function(value, i) {
                      let pos = "translate(" + (i*offset) + ", 0)";
                      return <g key={"tab"+i} transform={pos} onClick={this.select.bind(this, i)}>{value ? null : this.renderUnselectedTab(tabs[i])}</g>;
                  }, this)
              }
              {
                  focused.map(function(value, i) {
                      let pos = "translate(" + (i*offset) + ", 0)";
                      return <g key={"divide"+i} transform={pos}>{divide}</g>;
                  })
              }
              {
                  focused.map(function(value, i) {
                      let pos = "translate(" + (i*offset) + ", 0)";
                      return <g key={"tab"+i} transform={pos}>{value ? this.renderSelectedTab(tabs[i]) : null}</g>;
                  }, this)
              }              
            </g>
        );
        let gridLines = [];
        for (let i=1; i<=5; i++) {
            let width = this.dim[this.state.zoom].size + this.dim[this.state.zoom].charPadding;
            let x = 80 + (width) * i*10 - width/2 - this.dim[this.state.zoom].charPadding;
            gridLines.push(<rect key={"grid"+i} style={{fill:"#c2cad3", strokeWidth:0}} x={x - xOff} y={0} width={6} height={547}/>);
            gridLines.push(<text key={"gridtext"+i} style={{fill:"#b2bad8"}} fontSize="36px" fontWeight="800" x={x - xOff+20} y={36}>{i*10}</text>);
        }
        
        return (
            <div className="FighterStats">
              <svg className="fighter-header" width="100%" viewBox="0 0 1920 1080">
                <rect style={{fill:"#242424", strokeWidth:0}} x={0} y={0} width="100%" height={110} />
                <rect style={{fill:"#bccde3", strokeWidth:0}} x={0} y={110} width="100%" height={4} />                
                <rect style={{fill:"#3f7dd9", strokeWidth:0}} x={0} y={114} width="100%" height={106} />
                <rect style={{fill:"#242424", strokeWidth:0}} x={0} y={220} width="100%" height={8} />
                <path style={{fill:"#242424", strokeWidth:0}} d="M1488 224 L1538 174 L1920 174 L1920 224 Z" />                
                <path style={{fill:"#d2d5dc", strokeWidth:0}} d="M1523 232 L1574 182 L1920 182 L1920 232 Z" />
                <g className="fighter-body" transform="translate(0, 228)" width="100%"
                   onMouseDown={this.onMouseDown.bind(this)}
                   onMouseMove={this.onMouseMove.bind(this)}
                   onMouseUp={this.onMouseUp.bind(this)}
                   onWheel={this.onMouseScroll.bind(this)}>
                  <rect style={{fill:"#d2d5dc", strokeWidth:0}} x={0} y={0} width="100%" height={547} />
                  <rect style={{fill:"#818184 ", strokeWidth:0}} x={0} y={547} width="100%" height={158} />
                  {gridLines}
                  { chars }
                </g>
                <g transform="translate(157, 132)">
                  <path style={{fill:"#4d8deb", strokeWidth:0}} d="M43 70 C 0 70, 0 0, 43 0 L1346 0 L1276 70 Z"/>
                  <text style={{fill:"#e5e6e5", strokeWidth:0, fontSize:50, fontWeight:900}} x={160} y={53}>Battles</text>
                </g>
                
                <rect style={{fill:"#242424", strokeWidth:0}} x={0} y={933} width="100%" height={89}/>
                
                
                {svgTabs}
              </svg>
            </div>
        );
    }
}

export default FighterStats;
